import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

function ResetPassword(props) {
  return (
    <Card className="mb-0">
      <CardHeader className="mb-2" tag="h4">
        Reset Password
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="6">
            <FormGroup className="d-flex flex-column align-items-start">
              <Label>
                New Password <span className="text-danger">*</span>
              </Label>
              <Input
                name="password"
                type="password"
                autoComplete="off"
                placeholder="Enter new password"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup className="d-flex flex-column align-items-start">
              <Label>
                Confirm New Password <span className="text-danger">*</span>
              </Label>
              <Input
                name="confirmPassword"
                type="password"
                autoComplete="off"
                placeholder="Confirm new password"
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
      <CardFooter>
        <div className="d-flex justify-content-end mb-0">
          <Button color="secondary" onClick={props.handleCloseModal}>
            Cancel
          </Button>
          <Button color="default" type="submit">
            Save
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
}

export default ResetPassword;
